import { Input } from 'component/Input/Input'
import { useLatestCallback } from 'hook/useLatestCallback'
import { KeyboardEvent, ReactNode, useEffect, useState } from 'react'
import { parseIntFinite } from 'util/number'

type Props = {
  border?: boolean
  borderless?: boolean
  disabled?: boolean
  height?: number
  onChange(value: number | undefined): void
  panel?: boolean
  placeholder?: string
  upper?: boolean
  value: number | null | undefined
  before?: ReactNode
  clear?: ReactNode
  className?: string
}

export const InputNumber = (props: Props) => {
  const {
    border,
    borderless,
    disabled,
    height,
    onChange,
    panel,
    placeholder,
    upper,
    before,
    clear,
    className,
  } = props

  const [version, setVersion] = useState(0)
  const [text, setText] = useState('')
  const [focus, setFocus] = useState(false)
  const value = focus ? text : props.value?.toFixed() ?? ''

  function applyChange(text: string) {
    const value = parseIntFinite(text)
    onChange(value)
    setVersion(version + 1)
  }

  const updateText = useLatestCallback(() => {
    setText(props.value?.toFixed() ?? '')
  })

  useEffect(() => {
    if (version) updateText()
  }, [updateText, version])

  const onFocus = useLatestCallback((focus: boolean) => {
    if (focus) {
      setFocus(true)
      setText(value)
    } else {
      setFocus(false)
      applyChange(text)
      setText('')
    }
  })

  const onKeyDown = useLatestCallback((event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Escape') {
      applyChange('')
      setText('')
    }
    if (event.key === 'Enter') {
      applyChange(text)
    }
  })

  const onChangeInner = useLatestCallback((value: string | null) => {
    const text = value || ''
    setText(text.replace(/\D/g, ''))
  })

  return <Input
    border={border}
    borderless={borderless}
    clear={clear === true}
    disabled={disabled}
    height={height}
    inputMode="numeric"
    onChange={onChangeInner}
    onFocus={onFocus}
    onKeyDown={onKeyDown}
    panel={panel}
    placeholder={placeholder}
    upper={upper}
    value={value}
    before={before}
    className={className}
  />
}
